import React from "react";
import RealTimeLayout from "components/Common/RealTimeLayout";

const RealTimeDashboard = ({pageName,
    vehicle, 
    selectedDateRange,
    onChangeSelectedDateRange,
    onChangeDatePickerType,
    onChangeImei}) => {

  
    return(
        <>
            <RealTimeLayout vehicle={vehicle}/>
        </>
    )

}

export default RealTimeDashboard;